"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrophoneButton = MicrophoneButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
// import { Animated } from "react-native";
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
// import { Easing } from "react-native";
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_native_1 = require("react-native");
const Voice_1 = __importDefault(require("../ui-components/Voice"));
const useDevice_1 = require("../../hooks/useDevice");
const colors_1 = require("../../common/colors");
const SendButton_1 = require("./SendButton");
const VOICE_TIMEOUT = 10000;
const WEB_VOLUME_VISUAL_GAIN = 6;
function MicrophoneButton({ disabled, setSpeechText, isRecording, setIsRecording, typingMode, setTypingMode, timerRef, setMessageFocus, forceVoiceStop, setForceVoiceStop, setNewPitch, boxHeight, onPressInAction, inputText, sendMessage, onPress, style, }) {
    const { isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    const hasInputText = (0, react_1.useMemo)(() => (Boolean(inputText)), [inputText]);
    const speechStartHandler = (e) => {
        console.log("speechStart successful", e);
    };
    const speechEndHandler = (e) => {
        console.log("speechEndHandler", e);
        if (react_native_1.Platform.OS === "android") {
            onPressOut();
        }
    };
    function onSpeechVolumeChanged(e) {
        console.log("onSpeechVolumeChanged: ", e);
        setNewPitch?.((e?.value || 0) * (isWebDevice ? WEB_VOLUME_VISUAL_GAIN : 1));
    }
    function onSpeechPartialResults(e) {
        console.log("onSpeechPartialResults: ", e);
    }
    function onSpeechError(e) {
        console.log("onSpeechError: ", e);
        if (react_native_1.Platform.OS === "android") {
            Voice_1.default.destroy().then(Voice_1.default.removeAllListeners);
        }
        else {
            onPressOut();
        }
    }
    (0, react_1.useEffect)(() => {
        try {
            Voice_1.default.onSpeechResults = onSpeechResults;
            Voice_1.default.onSpeechStart = speechStartHandler;
            Voice_1.default.onSpeechEnd = speechEndHandler;
            Voice_1.default.onSpeechVolumeChanged = onSpeechVolumeChanged;
            Voice_1.default.onSpeechPartialResults = onSpeechPartialResults;
            Voice_1.default.onSpeechError = onSpeechError;
        }
        catch (e) {
            console.log("Voice error...");
        }
        return () => {
            if (isWebDevice) {
                Voice_1.default.removeAllListeners();
            }
            else {
                Voice_1.default.destroy().then(Voice_1.default.removeAllListeners);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (forceVoiceStop) {
            setForceVoiceStop(false);
            onPressOut();
        }
    }, [forceVoiceStop]);
    const onPressIn = (0, react_1.useCallback)(async () => {
        // Already recording so need to stop recording.
        if (isRecording) {
            console.log("Already recording...");
            return onPressOut();
        }
        onPressInAction?.();
        try {
            if (boxHeight)
                boxHeight.value = 0;
            console.log("Voice onPressIn...");
            setIsRecording(true);
            await Voice_1.default.start("en-US", isWebDevice ? { continuous: true } : undefined);
        }
        catch (error) {
            console.error(error);
        }
        clearTimeout(timerRef?.current);
        timerRef.current = setTimeout(() => {
            console.log("force in timeout....");
            // rippleStop();
            onPressOut();
        }, VOICE_TIMEOUT);
    }, [isRecording, boxHeight, timerRef]);
    const onPressOut = (0, react_1.useCallback)(async () => {
        console.log("onPressout...", typingMode);
        try {
            console.log("Voice onPressOut...", typingMode, isRecording);
            await Voice_1.default.stop();
            setTimeout(() => {
                console.log("Setting text focus...");
                setMessageFocus?.();
            }, 100);
            setIsRecording(false);
            setTypingMode("text");
            timerRef?.current && clearTimeout(timerRef.current);
        }
        catch (error) {
            console.error(error);
        }
    }, [typingMode, isRecording]);
    /**
     *
     * @param event
     */
    const onSpeechResults = (0, react_1.useCallback)(({ value }) => {
        const recognizedText = isWebDevice ? value?.[value.length - 1] : value?.[0];
        setSpeechText(inputText.concat(recognizedText ?? ""));
        clearTimeout(timerRef?.current);
        timerRef.current = setTimeout(() => {
            console.log("force stop now....");
            onPressOut();
        }, VOICE_TIMEOUT);
    }, [isWebDevice, inputText, onPressOut]);
    (0, react_1.useEffect)(() => {
        Voice_1.default.onSpeechResults = onSpeechResults;
    }, [onSpeechResults]);
    const handleSendMessage = (0, react_1.useCallback)(() => {
        sendMessage();
        onPressOut();
    }, [sendMessage, onPressOut]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: (event) => {
                console.log("Pressed...");
                onPressIn();
                onPress?.(event);
            }, style: [
                styles.speechButton,
                isWebDevice && isMobileScreen &&
                    {
                        height: 'auto',
                        width: 'auto',
                        marginLeft: 10,
                        marginRight: 4,
                    },
                style,
            ], disabled: disabled, children: (0, jsx_runtime_1.jsx)(native_base_1.Stack, { style: [
                    styles.linearGradient,
                    {
                        height: isWebDevice && isMobileScreen ? 32 : undefined,
                        width: isWebDevice && isMobileScreen ? 32 : undefined,
                    }
                ], children: (0, jsx_runtime_1.jsx)(native_base_1.VStack, { alignItems: "center", justifyContent: "center", flex: 1, children: hasInputText ? ((0, jsx_runtime_1.jsx)(SendButton_1.SendButton, { onPress: handleSendMessage })) : isRecording ? ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faStopCircle, color: colors_1.Colors.PRIMARY_300, size: 30 })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faMicrophone, color: colors_1.Colors.DARK_100, size: isWebDevice && isMobileScreen ? 20 : 18 })) }) }) }) }));
}
const styles = react_native_1.StyleSheet.create({
    linearGradient: {
        display: "flex",
        height: 40,
        width: 40,
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    linearGradientText: {
        textAlign: "center",
        margin: 0,
        paddingVertical: 12.5,
        fontSize: 16,
        color: "#FFFFFF",
        fontWeight: "bold",
    },
    speechButton: {
        marginRight: 10,
        borderRadius: 20,
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: "#f00",
    },
});
